export const MB = 1024 * 1024;
export const DEFAULT_MAX_IMAGE_UPLOAD_SIZE_MB = 20;
export const DEFAULT_MAX_IMAGE_UPLOAD_SIZE_BYTES = DEFAULT_MAX_IMAGE_UPLOAD_SIZE_MB * MB;
export const IMAGE_COMPRESSION_SCALE_STEP = 0.8;
export const INTERACTIVE_DIALOG_SIZE_STYLES = {
  width: '95vw',
  maxWidth: '700px'
};
export const PHOTO_PREVIEW_DIALOG_SIZE_STYLES = {
  ...INTERACTIVE_DIALOG_SIZE_STYLES,
  maxWidth: '90vw',
  maxHeight: '90vh'
};
